module.exports = __webpack_public_path__ + "img/H02071-112.6f402eeb.jpg";